// GENERATED FILE — do not edit by hand. Run `npm run combos` to regenerate.
// Region×dimension combos whose catalog inventory (from /metadata) meets the
// threshold, so their pages are not thin. Consumed by combos.ts.

export interface GeneratedCombo {
  /** Region slug (matches a region base page). */
  region: string
  /** Base facility/category landing slug (e.g. `se-saunou`, `chalupy`). */
  base: string
}

export const generatedCombos: GeneratedCombo[] = [
  { region: 'beskydy-a-valassko', base: 'chalupy' },
  { region: 'beskydy-a-valassko', base: 'pobyty-na-horach' },
  { region: 'beskydy-a-valassko', base: 'pro-psy' },
  { region: 'beskydy-a-valassko', base: 'romanticke-pobyty' },
  { region: 'beskydy-a-valassko', base: 's-krbem' },
  { region: 'beskydy-a-valassko', base: 's-virivkou' },
  { region: 'beskydy-a-valassko', base: 'se-saunou' },
  { region: 'beskydy-a-valassko', base: 'wellness-pobyty' },
  { region: 'ceske-svycarsko', base: 'pro-psy' },
  { region: 'ceske-svycarsko', base: 'romanticke-pobyty' },
  { region: 'ceske-svycarsko', base: 's-krbem' },
  { region: 'jeseniky', base: 'chaty' },
  { region: 'jeseniky', base: 'pobyty-na-horach' },
  { region: 'jeseniky', base: 'pro-psy' },
  { region: 'jeseniky', base: 'rodinne-pobyty' },
  { region: 'jeseniky', base: 's-krbem' },
  { region: 'jizerske-hory', base: 'chaty' },
  { region: 'jizerske-hory', base: 'glamping' },
  { region: 'jizerske-hory', base: 'pobyty-na-horach' },
  { region: 'jizerske-hory', base: 'rodinne-pobyty' },
  { region: 'jizerske-hory', base: 'romanticke-pobyty' },
  { region: 'jizerske-hory', base: 's-krbem' },
  { region: 'jizerske-hory', base: 's-virivkou' },
  { region: 'jizerske-hory', base: 'se-saunou' },
  { region: 'jizerske-hory', base: 'wellness-pobyty' },
  { region: 'jizni-a-stredni-morava', base: 'apartmany' },
  { region: 'jizni-a-stredni-morava', base: 'glamping' },
  { region: 'jizni-a-stredni-morava', base: 'pobyty-na-horach' },
  { region: 'jizni-a-stredni-morava', base: 'pro-psy' },
  { region: 'jizni-a-stredni-morava', base: 'rodinne-pobyty' },
  { region: 'jizni-a-stredni-morava', base: 'romanticke-pobyty' },
  { region: 'jizni-a-stredni-morava', base: 's-krbem' },
  { region: 'jizni-a-stredni-morava', base: 's-virivkou' },
  { region: 'jizni-a-stredni-morava', base: 'se-saunou' },
  { region: 'jizni-a-stredni-morava', base: 'wellness-pobyty' },
  { region: 'jizni-cechy', base: 'glamping' },
  { region: 'jizni-cechy', base: 'pobyty-na-horach' },
  { region: 'jizni-cechy', base: 'pobyty-u-vody' },
  { region: 'jizni-cechy', base: 'pro-psy' },
  { region: 'jizni-cechy', base: 'rodinne-pobyty' },
  { region: 'jizni-cechy', base: 'romanticke-pobyty' },
  { region: 'jizni-cechy', base: 's-kadi' },
  { region: 'jizni-cechy', base: 's-krbem' },
  { region: 'jizni-cechy', base: 's-virivkou' },
  { region: 'jizni-cechy', base: 'se-saunou' },
  { region: 'jizni-cechy', base: 'wellness-pobyty' },
  { region: 'krkonose', base: 'chalupy' },
  { region: 'krkonose', base: 'glamping' },
  { region: 'krkonose', base: 'pobyty-na-horach' },
  { region: 'krkonose', base: 'pro-psy' },
  { region: 'krkonose', base: 'rodinne-pobyty' },
  { region: 'krkonose', base: 'romanticke-pobyty' },
  { region: 'krkonose', base: 's-krbem' },
  { region: 'krkonose', base: 'se-saunou' },
  { region: 'krusne-hory', base: 'glamping' },
  { region: 'krusne-hory', base: 'pobyty-na-horach' },
  { region: 'krusne-hory', base: 'pro-psy' },
  { region: 'krusne-hory', base: 'romanticke-pobyty' },
  { region: 'krusne-hory', base: 's-krbem' },
  { region: 'krusne-hory', base: 'se-saunou' },
  { region: 'vychodni-cechy', base: 'glamping' },
  { region: 'vychodni-cechy', base: 'pro-psy' },
  { region: 'vychodni-cechy', base: 'rodinne-pobyty' },
  { region: 'vychodni-cechy', base: 'romanticke-pobyty' },
  { region: 'vychodni-cechy', base: 's-krbem' },
  { region: 'vychodni-cechy', base: 'se-saunou' },
  { region: 'vychodni-cechy', base: 'wellness-pobyty' },
  { region: 'vysocina', base: 'glamping' },
  { region: 'vysocina', base: 'pro-psy' },
  { region: 'vysocina', base: 'rodinne-pobyty' },
  { region: 'vysocina', base: 'romanticke-pobyty' },
  { region: 'vysocina', base: 's-krbem' },
  { region: 'vysocina', base: 's-virivkou' },
  { region: 'vysocina', base: 'wellness-pobyty' },
  { region: 'zapadni-cechy', base: 'glamping' },
  { region: 'zapadni-cechy', base: 'romanticke-pobyty' },
  { region: 'zapadni-cechy', base: 'se-saunou' },
  { region: 'zapadni-cechy', base: 'wellness-pobyty' },
]
